import { render, staticRenderFns } from "./ResultbcNotice.vue?vue&type=template&id=58363cfb"
import script from "./ResultbcNotice.vue?vue&type=script&lang=js"
export * from "./ResultbcNotice.vue?vue&type=script&lang=js"
import style0 from "./ResultbcNotice.vue?vue&type=style&index=0&id=58363cfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports